import t from "@/lang/lang";
import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Copy } from "lucide-react";
import { ReactNode, useState } from "react";
import { CpySources } from "./cpy-sources";
import { CpyName } from "../types/entity-names";
import { SourcesParams } from "@/services/backend/cpy/api/cpy";
import { CpySourcesTableFilterOptions } from "./cpy-sources-table";

/**
 * CpyDialog is a dialog showing available sources for the specified
 * destination.
 */
export function CpyDialog({
  destinationEntityName,
  destinationId,
  trigger,
  onCpySuccess,
  initialParams,
  description,
  disabled,
  ...props
}: {
  destinationEntityName: CpyName;
  destinationId: string;
  trigger?: ReactNode;
  onCpySuccess?: () => void;
  initialParams?: SourcesParams;
  description?: string;
  disabled?: boolean;
} & CpySourcesTableFilterOptions) {
  const [open, setOpen] = useState(false);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="outline" disabled={disabled}>
            <Copy />
            <span>{t("Daten kopieren")}</span>
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[80vw]">
        <DialogHeader>
          <DialogTitle>{t("Daten kopieren")}</DialogTitle>
          <DialogDescription>
            {description ||
              t(
                "Sie können in das vorliegende Dokument Daten aus den folgenden Quellen übernehmen. Die Resultate werden begrenzt. Es wird empfohlen nach der Dokumentennummer zu suchen.",
              )}
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[70vh] overflow-auto">
          <CpySources
            destinationEntityName={destinationEntityName}
            destinationId={destinationId}
            onCopySuccess={() => {
              setOpen(false);
              onCpySuccess?.();
            }}
            initialParams={initialParams}
            {...props}
          />
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t("Abbrechen")}</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
